/**
 * تحديد موقع المستخدم التقريبي عبر عنوان IP — صامت بلا نافذة إذن من المتصفح.
 * يُستخدم مرة واحدة عند أول زيارة فقط؛ بعدها يُحفظ الموقع في localStorage
 * (ضمن rasid:user-prefs) ويُستَخدم مباشرة في الزيارات التالية.
 */

export interface IpLocation {
    lat: number;
    lon: number;
    city?: string;
    country?: string;
}

// مفتاح تخزين "مدينة المستخدم" — تُكتشف مرة واحدة عبر IP وتُفتح الخريطة عليها في
// كل زيارة (وليس على آخر إحداثيات تنقّل إليها المستخدم على الخريطة).
const HOME_LOCATION_KEY = 'rasid:home-location';

export function readHomeLocation(): IpLocation | null {
    try {
        const raw = localStorage.getItem(HOME_LOCATION_KEY);
        if (!raw) return null;
        const loc = JSON.parse(raw);
        return Number.isFinite(loc?.lat) && Number.isFinite(loc?.lon) ? loc : null;
    } catch {
        return null;
    }
}

export function saveHomeLocation(loc: IpLocation): void {
    try {
        localStorage.setItem(HOME_LOCATION_KEY, JSON.stringify(loc));
    } catch { /* تخزين ممتلئ/معطّل — نتجاهل */ }
}

// GeoJS: مجاني، يدعم CORS، بلا مفتاح API.
const GEOJS_URL = 'https://get.geojs.io/v1/ip/geo.json';

export async function detectIpLocation(timeoutMs = 5000): Promise<IpLocation | null> {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
        const res = await fetch(GEOJS_URL, { signal: controller.signal });
        if (!res.ok) return null;
        const data = await res.json();
        const lat = parseFloat(data.latitude);
        const lon = parseFloat(data.longitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
        return { lat, lon, city: data.city, country: data.country };
    } catch {
        return null; // فشل الشبكة/المهلة ⇒ نبقى على الافتراضي (الرياض)
    } finally {
        clearTimeout(timer);
    }
}
